const bgLine = (bgColor, topWidth, bottomWidth) => `
  linear-gradient(
    to bottom,
    white,
    white ${topWidth}%,
    ${bgColor} ${topWidth}%,
    ${bgColor} ${bottomWidth}%,
    white ${bottomWidth}%,
    white
  )
`;
const whiteBlock = direction => `
  linear-gradient(
    to ${direction},
    white 0%,
    white 50%,
    transparent 50%,
    transparent 100%
  )
`;
function firstBgStyle(bgColor) {
  return {
    background: `${whiteBlock("right")}, ${bgLine(bgColor, 46, 54)}`
  };
}
function middleBgStyle(bgColor) {
  return {
    background: bgLine(bgColor, 46, 54)
  };
}
function lastBgStyle(bgColor) {
  return {
    background: `${whiteBlock("left")}, ${bgLine(bgColor, 48.5, 53.5)}`
  };
}
const verticalBgLine = (bgColor, topWidth, bottomWidth) => `
  linear-gradient(
    to right,
    white,
    white ${topWidth}%,
    ${bgColor} ${topWidth}%,
    ${bgColor} ${bottomWidth}%,
    white ${bottomWidth}%,
    white
  )
`;
function verticalFirstBgStyle(bgColor) {
  return {
    background: `${whiteBlock("bottom")}, ${verticalBgLine(bgColor, 46, 54)}`,
    paddingBottom: "1rem"
  };
}
function verticalMiddleBgStyle(bgColor) {
  return {
    background: verticalBgLine(bgColor, 46, 54),
    padding: "1rem 0"
  };
}
function verticalLastBgStyle(bgColor) {
  return {
    background: `${whiteBlock("top")}, ${verticalBgLine(bgColor, 46, 54)}`,
    paddingTop: "1rem"
  };
}
function calcBgStyles(bgColor, vertical) {
  if (vertical) {
    return {
      firstBgStyle: verticalFirstBgStyle(bgColor),
      middleBgStyle: verticalMiddleBgStyle(bgColor),
      lastBgStyle: verticalLastBgStyle(bgColor)
    };
  }
  return {
    firstBgStyle: firstBgStyle(bgColor),
    middleBgStyle: middleBgStyle(bgColor),
    lastBgStyle: lastBgStyle(bgColor)
  };
}
function bgStyles(bgColor, pos, vertical) {
  const styles = calcBgStyles(bgColor, vertical);
  if (pos === "first") {
    return styles.firstBgStyle;
  }
  if (pos === "last") {
    return styles.lastBgStyle;
  }
  return styles.middleBgStyle;
}
function calcTitleClassNames(pos, vertical) {
  const classNames = "slds-m-around_xx-small tds-progress-icon__title";
  if (vertical) {
    if (pos === "first") {
      return classNames.concat(" slds-p-bottom_medium");
    }
    if (pos === "last") {
      return classNames.concat(" slds-p-top_medium");
    }
  }
  return classNames;
}

export { bgStyles, calcTitleClassNames };
